import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { ArrowRight } from "@bw/icons"

const AddressWrapper = styled.address`
  font-style: normal;
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const Address = ({ street, city, zipCode, state, country, phone, email }) => {
  const { t } = useTranslation()
  const formatedCity = [zipCode, city].join(" ")
  const formatedCountry = [state, country].join(" ")

  // note that the double slash is important, that indicates that the
  // address append is where we want to go
  const url = "https://www.google.ch/maps/dir//"

  const geolocalization = encodeURIComponent([street, zipCode, city].join(" "))

  return (
    <>
      <AddressWrapper className="address">
        <div>
          {street}
          <br />
          {formatedCity.length > 1 ? (
            <>
              {formatedCity}
              <br />
            </>
          ) : null}
          {formatedCountry.length > 1 ? (
            <>
              {formatedCountry}
              <br />
            </>
          ) : null}
        </div>
        {phone}
        {email}
      </AddressWrapper>

      <a href={url + geolocalization} target="_blank" rel="noreferrer">
        <ArrowRight />
        {t("itinerary")}
      </a>
    </>
  )
}

Address.propTypes = {
  street: PropTypes.string,
}

export { Address }
